// extracted by mini-css-extract-plugin
module.exports = {"container":"_2KfyZVZj395uvg9fmfh3j0"};